// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"t-FiQ","offerDetailPercentage":"MK9qT","offerDetailImage":"KjxYw","offerDescription":"g5nYW"};